import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import { Icon, iconNames } from '../../Icon'

import css from './SettingSectionToggle.css'

export const SettingSectionToggle = ({
  isExpanded,
  icon,
  title,
  isMobile,
  renderCurrentValue,
  testingSelector,
}) => {
  const shouldRenderCurrentValue = (!isMobile && !isExpanded) || isMobile

  return (
    <Fragment>
      <div className={css.header}>
        <Icon name={icon} />
        <p data-testing={`${testingSelector}-title`} className={css.headerTitle}>
          {title}
        </p>
        <span className={css.headerCta} data-testing={`${testingSelector}-cta`}>
          {isExpanded ? 'Cancel' : 'Edit'}
        </span>
      </div>

      {shouldRenderCurrentValue && (
        <div data-testing={`${testingSelector}-current-value`} className={css.currentValue}>
          {renderCurrentValue}
        </div>
      )}
    </Fragment>
  )
}

SettingSectionToggle.propTypes = {
  isExpanded: PropTypes.bool,
  icon: PropTypes.oneOf(iconNames).isRequired,
  title: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  renderCurrentValue: PropTypes.node.isRequired,
  testingSelector: PropTypes.string,
}

SettingSectionToggle.defaultProps = {
  isExpanded: false,
  isMobile: false,
  testingSelector: '',
}
